var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('aaa',{ref:"loadmore",staticClass:"box",attrs:{"allLoaded":true,"pullDown":true},on:{"pullingDown":_vm.reload}},[_c('div',{staticClass:"aaaa"},[_vm._v("嗯")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }